import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-base-container',
  templateUrl: './base-container.component.html',
  styleUrls: ['./base-container.component.css'],
  standalone: false
})
export class BaseContainerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
